export default __webpack_public_path__ + "static/media/spaceport.55440a22.svg";